import React from 'react'
import {BsFacebook,BsGithub,BsTwitter,BsLinkedin} from 'react-icons/bs'
import { Link } from 'react-scroll';

function Footer() {
  return (
    <footer className='max-h-[85vh] lg:max-h-[70vh]'>
        <div className='container mx-auto'>
            <div className='flex flex-col items-center gap-y-3'>
                <h2 className='font-bold font-secondary text-2xl text-center'>Dahhou Ilyas</h2>
                <div className='flex flex-row gap-4'>
                    <Link className='cursor-pointer' to='about' activeClass='active' smooth={true} spy={true}><h3>About</h3></Link>
                    <Link className='cursor-pointer' to='services' activeClass='active' smooth={true} spy={true}><h3>Skills</h3></Link>
                    <Link className='cursor-pointer' to='work' activeClass='active' smooth={true} spy={true}><h3>Projects</h3></Link>
                </div>
                <div className='flex flex-row gap-3'>
                    <a  href='https://www.linkedin.com/in/ilyas-dahhou-b64229247/'>
                      <BsLinkedin/>
                    </a>
                    <a href='https://www.facebook.com/ilyass.dahhou.7/'>
                      <BsFacebook/>
                    </a>
                    <a href='https://github.com/dahhou-ilyas'>
                      <BsGithub/>
                    </a>
                    <a href='https://twitter.com/DahhouIlyas?t=nTw5GUTvsLMYIQtzo5iDDA&s=08'>
                      <BsTwitter/>
                    </a>
                </div>
                <span className='text-sm pt-5'>© 2023 - 2024</span>
            </div>
        </div>
    </footer>
  )
}

export default Footer